import Header from "./header/Header";
import Timeline from "./timeline/components/Timeline";

function App() {
  return (
    <div className="app">
      <Header />
      <p className="intro">
        As a Frontend Engineering Lead, I build and mentor high-performing teams while driving product innovation. Balancing technical expertise with leadership, I foster collaboration, ensure technical excellence, and align engineering efforts with business goals to deliver exceptional user experiences. Passionate about scaling teams and refining development processes, I create an environment where engineers can thrive and products can evolve efficiently.
      </p>
      <Timeline />
      <div className="copyright">&copy;{(new Date()).getFullYear()} - Daniel St. Germain</div>
    </div>
  );
}

export default App;
